module.exports = __webpack_public_path__ + "static/media/rugrats-post-game-bg.400d3ddb.png";